import React, { useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import {useDocTitle} from '../components/CustomHook';
import axios from 'axios';
import Notiflix from 'notiflix';
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";

const DemoProduct = (props) => {

    useDocTitle('AllyTopic | Order AI ScanWiz Pro')

    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [message, setMessage] = useState('')
    const [quantity, setQuantity] = useState('1')
    const [errors, setErrors] = useState([])

    const clearErrors = () => {
        setErrors([])
    }

    const clearInput = () => {
        setFirstName('')
        setLastName('')
        setEmail('')
        setPhone('')
        setMessage('')
        setQuantity('1')
    }
    
    function sendEmail(e) {
        e.preventDefault();
        document.getElementById('submitBtn').disabled = true;
        document.getElementById('submitBtn').innerHTML = 'Sending...';
        let fData = new FormData();
        fData.append('access_key', '42eed4b3-95a1-4401-9a7f-9eca480f15e2')
        fData.append('first_name', firstName)
        fData.append('last_name', lastName)
        fData.append('email', email)
        fData.append('phone_number', phone)
        fData.append('message', message)
        fData.append('products', `AI ScanWiz Pro (AT-29384) x${quantity}`)

        axios({
            method: "post",
            url: process.env.REACT_APP_DEMO_REQUEST_API,
            data: fData,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(function (response) {
            document.getElementById('submitBtn').disabled = false;
            document.getElementById('submitBtn').innerHTML = 'Place Order';
            clearInput()
            Notiflix.Report.success(
                'Order Received!',
                'Thanks for your order! Our team will be in touch shortly to confirm and arrange delivery.',
                'Okay',
            );
        })
        .catch(function (error) {
            document.getElementById('submitBtn').disabled = false;
            document.getElementById('submitBtn').innerHTML = 'Place Order';
            const { response } = error;
            if (response && response.status === 500) {
                Notiflix.Report.failure(
                    'An error occurred',
                    response.data.message,
                    'Okay',
                );
            }
            if (response && response.data.errors !== null) {
                setErrors(response.data.errors)
            }
        });
    }

    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Order AI ScanWiz Pro" });

    return (
        <>
            <div>
                <NavBar />
            </div>
            <div className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24">
                <div className="container mx-auto my-8 px-4 lg:px-20" data-aos="zoom-in">
                    <form onSubmit={sendEmail} id="demoProductForm">
                        <div className="flex flex-col lg:flex-row gap-8">
                            {/* Left: Form */}
                            <div className="w-full bg-white p-8 lg:p-12 rounded-2xl shadow-2xl lg:w-7/12">
                                {/* Header */}
                                <div className="mb-6">
                                    <span className="text-blue-600 font-bold uppercase text-xs tracking-widest border-l-4 border-blue-600 pl-3">Order Now</span>
                                    <h1 className="font-bold text-blue-900 text-3xl mt-2">Get Your AI ScanWiz Pro</h1>
                                    <p className="text-gray-500 mt-2">Fill in your details and our team will confirm your order and arrange delivery.</p>
                                </div>

                                {/* Product Summary */}
                                <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 mb-6 flex items-center gap-4">
                                    <div className="bg-blue-900 rounded-xl p-3 text-white flex-shrink-0">
                                        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <p className="font-bold text-blue-900 text-lg">AI ScanWiz Pro</p>
                                        <p className="text-gray-500 text-sm">AT-29384 · Version 5.2 · Bluetooth 4.0 OBD2 Adapter + AI App</p>
                                    </div>
                                </div>

                                {/* Quantity */}
                                <div className="mb-4">
                                    <label className="block text-sm font-semibold text-gray-700 mb-1">Quantity</label>
                                    <select
                                        className="w-full bg-gray-100 text-gray-900 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                        value={quantity}
                                        onChange={(e) => setQuantity(e.target.value)}
                                    >
                                        {[1,2,3,4,5,10].map(n => (
                                            <option key={n} value={n}>{n} unit{n > 1 ? 's' : ''}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Name fields */}
                                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-2">
                                    <div>
                                        <input
                                            name="first_name"
                                            className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                            type="text"
                                            placeholder="First Name*"
                                            value={firstName}
                                            onChange={(e) => setFirstName(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors && <p className="text-red-500 text-sm">{errors.first_name}</p>}
                                    </div>
                                    <div>
                                        <input
                                            name="last_name"
                                            className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                            type="text"
                                            placeholder="Last Name*"
                                            value={lastName}
                                            onChange={(e) => setLastName(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors && <p className="text-red-500 text-sm">{errors.last_name}</p>}
                                    </div>
                                    <div>
                                        <input
                                            name="email"
                                            className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                            type="email"
                                            placeholder="Email Address*"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors && <p className="text-red-500 text-sm">{errors.email}</p>}
                                    </div>
                                    <div>
                                        <input
                                            name="phone_number"
                                            className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                            type="tel"
                                            placeholder="Phone Number*"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                            onKeyUp={clearErrors}
                                        />
                                        {errors && <p className="text-red-500 text-sm">{errors.phone_number}</p>}
                                    </div>
                                </div>

                                <div className="my-4">
                                    <textarea
                                        name="message"
                                        placeholder="Shipping address or additional notes..."
                                        className="w-full h-28 bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        onKeyUp={clearErrors}
                                    ></textarea>
                                    {errors && <p className="text-red-500 text-sm">{errors.message}</p>}
                                </div>

                                <button
                                    type="submit"
                                    id="submitBtn"
                                    className="uppercase text-sm font-bold tracking-wide bg-blue-900 hover:bg-blue-700 text-white p-4 rounded-xl w-full focus:outline-none transition-colors duration-200"
                                >
                                    Place Order
                                </button>
                            </div>

                            {/* Right: Product info panel */}
                            <div className="w-full lg:w-5/12 bg-blue-900 rounded-2xl p-8 text-white flex flex-col justify-between">
                                <div>
                                    <h2 className="text-2xl font-bold mb-2">AI ScanWiz Pro</h2>
                                    <p className="text-blue-300 text-sm mb-6">AT-29384 · Version 5.2</p>

                                    <ul className="space-y-4 mb-8">
                                        {[
                                            { icon: '📶', text: 'Bluetooth 4.0 — seamless iOS & Android pairing' },
                                            { icon: '🔌', text: 'OBDII/EOBD support — all 9 protocols' },
                                            { icon: '🤖', text: 'AI chat — ask your car anything in plain English' },
                                            { icon: '⚡', text: 'Real-time Check Engine Light diagnostics' },
                                            { icon: '🚗', text: 'Universal 12V vehicle compatibility' },
                                            { icon: '📦', text: 'Pocket-sized Super MINI design' },
                                            { icon: '🛡️', text: '1-Year Warranty (registration required)' },
                                        ].map((item, i) => (
                                            <li key={i} className="flex items-start gap-3">
                                                <span className="text-xl flex-shrink-0">{item.icon}</span>
                                                <span className="text-blue-100 text-sm">{item.text}</span>
                                            </li>
                                        ))}
                                    </ul>

                                    <div className="border-t border-blue-800 pt-4 mb-4">
                                        <p className="text-blue-300 text-xs font-bold uppercase tracking-widest mb-2">Certifications</p>
                                        <div className="flex gap-3">
                                            {['CE', 'RoHS', 'FCC', 'UKCA'].map(c => (
                                                <span key={c} className="bg-blue-800 text-white text-xs font-bold px-2 py-1 rounded">{c}</span>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-6 border-t border-blue-800 pt-6">
                                    <h3 className="text-lg font-bold mb-3">Questions?</h3>
                                    <div className="space-y-2">
                                        <p className="text-blue-200 text-sm">
                                            <span className="font-semibold">Call us:</span>{' '}
                                            <Link to="tel:+18443912559" className="text-blue-300 hover:text-white">+1 844-391-ALLY</Link>
                                        </p>
                                        <p className="text-blue-200 text-sm">
                                            <span className="font-semibold">Email:</span>{' '}
                                            <Link to="mailto:sales@allytopic.com" className="text-blue-300 hover:text-white">sales@allytopic.com</Link>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default DemoProduct;
